import unionWith from 'lodash.unionwith'
import {
  ADD_DEFAULT_PRODUCTS,
  ADD_PRODUCTS_STORES,
  REMOVE_PRODUCTS_STORES,
  UPDATE_PRODUCTS_STORES,
  UPDATE_PRODUCTS_STORES_PRICE,
} from '../action-list'

/**
 * This is a mapping of key => product_store
 */
const initialState = []

const sameProductStore = (x, y) =>
  x.store_id === y.store_id && x.product_id === y.product_id

const isInScope = (productStore, scope) => {
  if ('productId' in scope) return productStore.product_id === scope.productId
  return productStore.store_id === scope.storeId
}

export default (state = initialState, action) => {
  switch (action.type) {
    case ADD_DEFAULT_PRODUCTS:
    case ADD_PRODUCTS_STORES: {
      const { payload: productsStores } = action
      return unionWith(productsStores, state, sameProductStore)
    }
    case UPDATE_PRODUCTS_STORES: {
      const { productsStores, scope } = action.payload
      const outOfScope = state.filter(
        (productStore) => !isInScope(productStore, scope),
      )
      return unionWith(productsStores, outOfScope, sameProductStore)
    }
    case REMOVE_PRODUCTS_STORES: {
      const { payload: productsStores } = action
      const keysToRemove = productsStores.map(
        (productStore) => `${productStore.store_id}#${productStore.product_id}`,
      )
      return state.filter(
        (productStore) =>
          !keysToRemove.includes(
            `${productStore.store_id}#${productStore.product_id}`,
          ),
      )
    }
    case UPDATE_PRODUCTS_STORES_PRICE: {
      const { payload: priceUpdate } = action
      const priceStateUpdate = {
        ...state.find(
          (p) =>
            p.product_id == priceUpdate.product_id &&
            p.store_id == priceUpdate.store_id,
        ),
        price: priceUpdate.price,
      }
      return unionWith([priceStateUpdate], state, sameProductStore)
    }
    default:
      return state
  }
}
